// Module
var code = "<user-notifications-panel></user-notifications-panel> ";
// Exports
export default code;